import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <FAQSection />
        <CardsSection />
        <IndexSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <MediaSection />
        <RankingSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}